import React from 'react';
import { BaseIcon } from '../base/BaseIcon';
import { IconProps } from '../types';

export const NavMarketActiveIcon = React.memo<IconProps>(
  ({
    className = '',
    size = 24,
    color = 'currentColor',
    onClick,
    strokeWidth,
  }) => (
    <BaseIcon
      className={className}
      size={size}
      color={color}
      onClick={onClick}
      viewBox="0 0 24 24"
      strokeWidth={strokeWidth}
    >
      <path
        d="M23.55 7.82999L20.37 1.45999C20.24 1.20999 19.98 1.04999 19.7 1.04999H4.3C4.02 1.04999 3.76 1.20999 3.63 1.45999L0.44 7.83999C0.31 8.09999 0.25 8.37999 0.25 8.66999V9.76999C0.25 10.79 0.67 11.7 1.35 12.42V22.97C1.35 23.38 1.69 23.72 2.1 23.72H21.9C22.31 23.72 22.65 23.38 22.65 22.97V12.42C23.33 11.71 23.75 10.79 23.75 9.77999V8.67999C23.75 8.39999 23.68 8.10999 23.55 7.84999V7.82999ZM14.67 22.21H9.32V16.99H14.67V22.21ZM21.15 22.21H15.92V16.36C15.92 16.02 15.64 15.74 15.3 15.74H8.7C8.35 15.74 8.08 16.02 8.08 16.36V22.21H2.85V13.44C4.7 14.29 7.25 13.6 8.33 12.01C9.12 13.09 10.47 13.8 12 13.8C13.53 13.8 14.87 13.09 15.67 12.01C16.76 13.6 19.31 14.28 21.15 13.44V22.21Z"
        fill={color}
      />
    </BaseIcon>
  ),
);

NavMarketActiveIcon.displayName = 'NavMarketActiveIcon';
